import { HTTP} from "@/services/HTTPService"
import store from '../../store'

export default {
  async getTimeslotsAvailable(date) {
    const segmentState = store.state.user.segment
    const params = {
      date,
      tz_offset: segmentState.tz_offset,
      segment: segmentState.id
    }
    const response = await HTTP.get('/timeslots/get_available/', {params})
    return response.data
  },
  async getTimeslotsStatistic(date, tags = []) {
    const segmentState = store.state.user.segment
    const params = {
      date,
      tz_offset: segmentState.tz_offset,
      segment: segmentState.id
    }

    if (tags && tags.length) {
      params['distribution_tag_ids'] = tags.map(tag => tag.tag_id).filter(tag => !!tag).join(',')
    }

    const response = await HTTP.get('/timeslots/get_statistic/', {params})
    return response.data
  },
  async getMonthTimeslots(date_time, offset) {
    const segmentState = store.state.user.segment
    const params = {
      date_time,
      tz_offset: offset,
      segment: segmentState.id
    }
    const response = await HTTP.get('/timeslots/get_month/', {params})
    return response.data
  }
}